<template>
  <ds-modal
    ref="modal"
    :title="title"
    size="small">
    <template slot="body">
      <ds-form
        :is-valid.sync="isFormValid"
        :on-submit="onSubmit">
        <ds-row>
          <ds-col size="6">
            <ds-field label="Dia">
              <ds-input
                v-model="day"
                type="number"
                maxlength="2"
                required>
              </ds-input>
            </ds-field>
          </ds-col>

          <ds-col size="6">
            <ds-field label="Mês">
              <ds-select v-model="month" required>
                <ds-option key="0" value="0">Janeiro</ds-option>
                <ds-option key="1" value="1">Fevereiro</ds-option>
                <ds-option key="2" value="2">Março</ds-option>
                <ds-option key="3" value="3">Abril</ds-option>
                <ds-option key="4" value="4">Maio</ds-option>
                <ds-option key="5" value="5">Junho</ds-option>
                <ds-option key="6" value="6">Julho</ds-option>
                <ds-option key="7" value="7">Agosto</ds-option>
                <ds-option key="8" value="8">Setembro</ds-option>
                <ds-option key="9" value="9">Outubro</ds-option>
                <ds-option key="10" value="10">Novembro</ds-option>
                <ds-option key="11" value="11">Dezembro</ds-option>
              </ds-select>
            </ds-field>
          </ds-col>

          <ds-col>
            <ds-field label="Descrição">
              <ds-input v-model="description"></ds-input>
            </ds-field>
          </ds-col>
        </ds-row>
      </ds-form>
    </template>

    <ds-row slot="footer">
      <ds-col size="3">
        <ds-button full-width @click="$refs.modal.close()">
          Cancelar
        </ds-button>
      </ds-col>
      <ds-col offset="6" size="3">
        <ds-request-button
          :disabled="!isFormValid"
          :on-request="onSubmit"
          :on-request-success="onSubmitSuccess"
          :on-request-error="onSubmitError"
          full-width
          theme="primary">
          Confirmar
        </ds-request-button>
      </ds-col>
    </ds-row>
  </ds-modal>
</template>

<script>
import moment from 'moment';
import { create } from '../holidayService';

export default {
  name: 'CreateHolidayModal',
  props: {
    year: String,
  },
  data() {
    return {
      day: null,
      month: '0',
      description: null,
      isFormValid: false,
    };
  },
  computed: {
    title() {
      return `Adicionar feriado em ${this.year}`;
    },
  },
  watch: {
    day() { this.onChangeDate(this.day, this.month); },
    month() { this.onChangeDate(this.day, this.month); },
  },
  methods: {
    onChangeDate(day, month) {
      this.isFormValid = moment({ day, month, year: this.year }).isValid();
    },
    onSubmit() {
      const holiday = {
        data: moment({ day: this.day, month: this.month, year: this.year }).format('DD/MM/YYYY'),
        descricao: this.description,
      };
      return create(holiday);
    },
    onSubmitSuccess() {
      this.$refs.modal.close();
      this.$toaster.success('Feriado criado com sucesso!');
      this.$emit('created', this.service);
    },
    onSubmitError() {
      this.$toaster.error('Aconteceu um erro, por favor tente novamente.');
    },
  },
};
</script>
